"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const f2e_endpoint_1 = require("@kiki/f2e.endpoint");
exports.config = {
    header: {
        method: 'POST',
        headers: {
            Accept: 'application/json;charset=utf-8',
            'Content-Type': 'application/json',
        },
    },
    website: 'https://www.kikitrade.com',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.kikitrade',
    appStoreUrl: 'https://apps.apple.com/us/app/kikitrade-crypto-for-everyone/id1507120441',
    branchLink: 'https://db3u.test-app.link/MH0FFgc5d4',
    websocket: f2e_endpoint_1.endpoint.websocket,
    supportUrl: f2e_endpoint_1.endpoint.api.supportUrl,
    api: {
        host: f2e_endpoint_1.endpoint.api.host,
        host_newapi: f2e_endpoint_1.endpoint.api.host_newapi,
        host_api_v1: f2e_endpoint_1.endpoint.api.host_api_v1,
        traceUrl: `${f2e_endpoint_1.endpoint.api.traceHost}/opentelemetry/v1/traces`,
        kline_url: f2e_endpoint_1.endpoint.api.kline_url,
        kiki_website_url: f2e_endpoint_1.endpoint.api.kiki_website_url,
        profit_chart_url: f2e_endpoint_1.endpoint.api.profit_chart_url,
        explore_areaChart_url: f2e_endpoint_1.endpoint.api.explore_areaChart_url,
        explore_compareLineChart_url: f2e_endpoint_1.endpoint.api.explore_compareLineChart_url,
        explore_stackBarChart_url: f2e_endpoint_1.endpoint.api.explore_stackBarChart_url,
        explore_VSChart_url: f2e_endpoint_1.endpoint.api.explore_VSChart_url,
        explore_analysisChart_url: f2e_endpoint_1.endpoint.api.explore_analysisChart_url,
        explore_areaChart_remote_url: f2e_endpoint_1.endpoint.api.explore_areaChart_remote_url,
        market_chart_url: f2e_endpoint_1.endpoint.api.market_chart_url,
        liveness_react_app_url: f2e_endpoint_1.endpoint.api.liveness_react_app_url,
        upload_api: f2e_endpoint_1.endpoint.api.upload_api,
        share: f2e_endpoint_1.endpoint.api.share,
        simple_kline_host: f2e_endpoint_1.endpoint.api.simple_kline_host,
        new_simple_kline_host: f2e_endpoint_1.endpoint.api.new_simple_kline_host,
        google_web_clientId: f2e_endpoint_1.endpoint.api.google_web_clientId,
        localeUpdate: 'customer/locale/update',
        get_short_link_url: f2e_endpoint_1.endpoint.api.get_short_link_url,
        otc: {
            payment: 'otc/payment',
            paymentWayAdd: 'otc/customer/paymentWay/add',
            paymentWayModify: 'otc/customer/paymentWay/modify',
            paymentWayRemove: 'otc/customer/paymentWay/remove',
            paymentWayDetail: 'otc/customer/paymentWay/detail',
            paymentWayList: 'otc/customer/paymentWay/list',
            depositRemarkcode: 'otc/customer/deposit/remarkcode',
            depositApply: 'otc/order/deposit/apply',
            depositDetail: 'otc/order/deposit/detail',
            depositList: 'otc/order/deposit/list',
            withdrawApply: 'otc/order/withdraw/apply',
            withdrawDetail: 'otc/order/withdraw/detail',
            withdrawList: 'otc/order/withdraw/list',
        },
        social: {
            getToken: 'api/social/getToken',
            ossKey: 'api/social/assumeRole',
            recommend: 'api/social/recommend',
            topicCategory: 'api/social/topic/category',
            topicAll: 'api/social/topic/all',
            topicPostFeed: 'api/social/topic/{topicId}/post',
            topicDetail: 'api/social/topic/{topicId}',
            hotUsers: 'api/social/users/hot',
            usersSearch: 'api/social/users/search',
            hotTopic: 'api/social/topic/hot',
            storyRecommend: 'api/social/story/recommend',
            storySquare: 'api/social/story/square',
            syncTrading: 'api/social/user/{id}/syncTrading',
            discussionFeed: 'api/social/enrich/symbol/feed/{userId}',
            userView: 'api/social/user/{userId}/view',
            search: 'v1/search',
            getLikedList: 'api/social/feed/reactions',
            languageZone: 'api/social/system/country/zone',
            updateLanguageZone: 'api/social/user/{id}/zone',
            wonderfulComments: 'api/social/feed/comment/splendid',
            deleteWonderfulComment: 'api/social/feed/splendidComment/{userId}/{viewId}',
            getFeaturedfeed: 'api/social/feed/post/splendid'
        },
        kol: {
            kolsByType: 'api/social/users/kol/{type}',
            batchFollow: 'api/social/user/{userId}/batchFollow',
        },
        cfd: {
            symbolList: 'cfd/symbol/listInfo',
            spotSymbolList: 'cfd/symbol/spot/listInfo',
            swapSymbolList: 'cfd/symbol/swap/listInfo',
            otcSymbolList: 'cfd/symbol/otc/listInfo',
            symbolListNew: 'v1/market/symbols/names',
            marketSymbols: 'v1/market/symbols',
            offlineSymbols: 'v1/market/symbols/offline',
            contractBalance: 'cfd/contract/balance',
            contractInfo: 'cfd/contract/info',
            configLever: 'cfd/config/lever',
            marginRate: 'cfd/config/marginRate',
            addEntrust: 'cfd/entrust/add',
            entrustList: 'cfd/entrust/list',
            orderList: 'cfd/order/list',
            closeOrder: 'cfd/order/close',
            stopLossTakeProfitOrder: 'cfd/order/sltp/config',
            cancelEntrust: 'cfd/entrust/cancel',
            marketPrice: 'cfd/contract/price',
            fundingFees: 'cfd/funding/fee/list',
            orderLiteList: 'cfd/order/lite/list',
        },
        revoke: {
            cryptoCancel: 'v1/pay/crypto/orders/{id}/cancel',
            fiatCancel: 'v1/pay/fiat/withdraw/cancel',
        },
        trade: {
            acquireOrderId: 'v1/trading/order/id',
            marginBalance: 'v1/trading/balance',
            tradingInfo: 'v1/trading/info',
            riskInfo: 'v1/trading/risk/info',
            changeMargin: 'v1/trading/margin',
            order: 'v1/trading/orders',
            cancelOrder: 'v1/trading/orders/{orderId}',
            patchCancelOrder: 'v1/trading/orders',
            orderDetail: 'v1/trading/orders/{orderId}',
            orderDetailFull: 'v1/trading/orders/{orderId}/detail',
            ordersOpen: 'v1/trading/openOrders',
            ordersHistory: 'v1/trading/orders',
            tradingTrades: '/v1/trading/trades',
            tradingTrade: 'v1/trading/trades/{tradeId}',
            zoneList: 'v1/market/zones',
            zoneDetail: 'v1/market/zones/{key}/{currency}',
            currencyDetail: 'v1/market/currencies/{currency}',
            orderbooks: '/v1/market/orderbooks/{symbol}',
            marginInterests: 'v1/trading/margin/interests/transactions',
            marginSettleOrders: 'v1/trading/margin/settle/orders',
            changeAssetAnalysis: 'v1/trading/assetStatistics',
            baseCurrencies: 'v1/market/currencies/baseCurrencies',
            klinesDays: 'v1/market/klines/days',
            shareSymbols: 'v1/trading/share/symbols',
        },
        config: {
            tabShow: 'cfd/config/tabShow',
        },
        cfdCopy: {
            copyOrder: 'copy/order/start',
            uncopyOrder: 'copy/order/close',
            balance: 'copy/balance',
            orderProfitModeModify: 'copy/order/sltp/config',
            copyOrderConfigQuery: 'copy/info',
            copyOrderList: 'copy/order/list',
            copyOrderDetail: 'copy/order/detail',
            copyFollowerRanking: 'copy/profit/ranking',
        },
        cfdTrader: {
            modifyDrawRate: 'trader/drawRate/modify',
            tokenSource: 'cfd/token/source',
            tokenApply: 'cfd/token/apply',
            tokenModify: 'cfd/token/modify',
            tokenRemove: 'cfd/token/remove',
            tokenQuery: 'cfd/token/get',
            traderPosition: 'trader/positions', // -->/type/customerId
        },
        spot: {
            placeOrder: 'spot/order',
            listOrders: 'spot/order/list/new',
            entrustCancel: 'spot/entrust/cancel',
            entrustShare: 'v1/trading/share/entrusts/{orderId}',
            historyOrdersShare: 'v1/trading/share/orders/{orderId}',
            entrustList: 'spot/entrust/list',
        },
        support: {
            sign: 'support/sign',
        },
        login: {
            login: 'customer/login',
            login_oauth: 'customer/login/oauth', //
        },
        customer: {
            customer: 'customer',
            sendEmailCode: 'customer/verify/send/email/code',
            sendPhoneCode: 'phone/auth/code',
            bindPhone: 'phone/auth/binding',
            unBindPhone: 'phone/auth/remove',
            bindEmail: 'email/auth/binding',
            unBindEmail: 'email/auth/remove',
            verify: 'customer/verify',
            verifyGoogle: 'google/auth',
            register: 'customer/register',
            logout: 'customer/logout',
            forgotPwd: 'customer/pwd/forgot',
            forgotPwdNew: 'customer/pwd/forgot/new',
            pwdReset: 'customer/pwd/reset',
            fullVerify: 'customer/full/verify',
            rebateInfo: 'rebate/get/rebate/baseinfo',
            rebateHistory: 'rebate/get/reward/history',
            verifyRebateCode: 'rebate/verify/code',
            referInfo: 'rebate/refer',
            device: 'v1/customer/device',
            update: 'customer/extra/update',
            securityVerify: 'v1/customer/verify/security',
            updateCustomerInfo: 'customer',
            imSign: 'v1/customer/im/sign',
            imBind: 'v1/customer/im/bind',
            assetPassword: 'v1/customer/password/asset',
            assetPwdVerify: 'v1/customer/verify/password/asset',
        },
        kline: {
            hoursKLine: 'v1/market/klines/hours',
        },
        account: {
            assetsDetail: 'v1/assets/{coinCode}',
            withdrawConfig: 'v1/pay/crypto/configs/{coinCode}',
            withdrawAllConfig: 'v1/pay/currencies',
            info: 'account/info',
            assets: 'account/assets',
            balance: 'account/getVirtualAccount',
            history: 'account/getCoinHistory',
            coinList: 'v1/market/currencies',
            depositAddress: 'dm/deposit/inner/address',
            showDepositAddress: 'dm/deposit/inner/address/show',
            currency: 'currency',
            transactionList: 'dm/transaction/list',
            transfer: 'account/transfer',
            withdrawFee: 'dm/withdraw/fees',
            withdrawApply: 'dm/withdraw/apply',
            yuebaoProductList: 'yuebao/productList',
            yuebaoTransfer: 'yuebao/transfer',
            depositStatus: 'v1/pay/success/deposit/',
        },
        accountV1: {
            transactionList: 'v1/pay/crypto/transactions',
            delWithdrawAddress: 'v1/wallet/addresses/{asset}/withdraw/{addressId}',
            withdrawAddress: 'v1/wallet/addresses/{asset}/withdraw',
            depositAddress: 'v1/wallet/addresses/{asset}',
            withdrawApply: 'v1/pay/crypto/withdraw/{asset}',
            showDepositAddress: 'v1/wallet/addresses/{asset}',
            payCurrenciesInfo: 'v1/pay/currencies/{currency}',
            assetOrderList: 'v1/pay/crypto/orders',
            getTodaysPNL: 'v1/assets/statistics/params',
            getAssetCurrencies: 'v1/assets/statistics/positions/currencies',
            assetCurrenciesData: 'v1/assets/statistics/positions/{currency}',
            assetPnlDetail: 'v1/assets/statistics/overview',
            assetsList: 'v1/assets',
        },
        vip: {
            upgrade: 'v1/member/upgrade',
            levels: 'v1/member/levels',
            levelsLight: 'v1/member/levels/light',
            equities: 'v1/member/equities/{type}',
            taskList: 'v1/member/task/{type}',
            rankList: 'v1/member/ladder/{type}',
            completeTask: 'v1/member/task/complete/{code}',
            pointLedgers: 'v1/member/points/ledgers/{type}',
            membership: 'v1/member/membership',
        },
        google: {
            key: 'google/auth/key',
            binding: 'google/auth/binding',
            auth: 'google/auth',
            remove: 'google/auth/remove',
        },
        activity: {
            luckyBoxCount: '/cfd/activity/luckybox/remain',
            addLuckyBoxCount: '/cfd/activity/luckybox/addOneTime',
            openLuckyBox: '/cfd/activity/luckybox/open',
            getLuckyBoxResult: '/cfd/activity/luckybox/check',
            getLuckyBoxRecords: '/cfd/activity/luckybox/records/winning',
            redeem: 'redeemcard/redeem',
            history: 'redeemcard/history',
            redeemcardBuy: 'redeemcard/buy',
            buyHistory: 'redeemcard/buy/history',
            buyCards: 'redeemcard/buy/cards',
            referredRanking: 'cfd/activity/referred/ranking',
            inviteCode: 'customer/inviteCode',
            slotReferred: 'cfd/activity/slot/referred',
            giftRemarkCode: 'redeemcard/buy/remarkcode',
            invitaRecord: 'v1/customer/invitees',
            inviteAwards: 'rebate/rewards',
            updateInviteCode: 'v1/customer/invite/code',
        },
        kyc: {
            kycResult: 'v1/kyc/result',
            kycToken: 'kyc/token',
            kycLiveness: 'kyc/liveness',
            kycOcrUpload: 'kyc/ocr/upload',
            kycVipUpload: 'v1/kyc/l2/apply',
        },
        credit: {
            channels: 'v1/quickpay/channels',
            currencies: 'v1/quickpay/currencies',
            orders: 'v1/quickpay/orders',
            ordersEstimate: 'v1/quickpay/estimate/orders',
            channelsContact: 'v1/quickpay/channels/{channelId}',
            channelsPay: 'v1/quickpay/orders/{channelId}/{orderId}/pay',
        },
        c2c: {
            cancelCount: 'p2p/order/cancel/count',
            merchantConfig: 'p2p/merchant/config',
            orderPlace: 'p2p/order/place',
            orderAppeal: 'p2p/order/appeal',
            payerConfirm: 'p2p/order/payer/confirm',
            payeeConfirm: 'p2p/order/payee/confirm',
            orderCancel: 'p2p/order/cancel',
            areaAdsList: 'v1/p2p/merchant/area/ads/list',
            adsDetail: 'p2p/merchant/ads/detail',
            orderList: 'p2p/order/list',
            orderDetail: 'p2p/order/detail',
            p2pOrderList: 'v1/p2p/order/asset',
            p2pOrderChat: 'v1/p2p/order/{id}/chat',
        },
        explore: {
            getLongShort: 'api/data/longshort',
            getList: 'api/data/list',
            getLiquidation: 'api/data/liquidation',
            getFundingfee: 'api/data/fundingfee',
            getFearAndGreedIndex: 'api/data/fearAndGreedIndex',
            getStockDataIndex: 'api/data/stockDataIndex',
        },
        earnings: {
            financingAccount: 'financing/account',
            financingProducts: 'financing/products',
            financingProductsAuto: 'financing/products/auto/currencies',
            financingAutoSubscribe: 'financing/auto/subscribe',
            financingProductsSubscribeDetail: 'financing/products/{productId}/subscribe',
            financingProductsRedeemDetail: 'financing/products/{productId}/redeem',
            financingContracts: 'financing/contracts',
            financingContractsHistory: 'financing/contracts/history',
            investmentProducts: 'investment/products',
            investmentProductsSubscribeDetail: 'investment/products/{productId}/subscribe',
            investmentContracts: 'investment/contracts',
            investmentContractsRenameDetail: 'investment/contracts/{contractId}/rename',
            investmentContractsHistoryDetail: 'investment/contracts/{contractId}/history',
            investmentContractsHistory: 'investment/contracts/history',
            investmentContractsPauseDetail: 'investment/contracts/{contractId}/pause',
            investmentContractsResumeDetail: 'investment/contracts/{contractId}/resume',
            investmentContractsStopDetail: 'investment/contracts/{contractId}/stop',
            investmentContractsAutoFinancingDetail: 'investment/contracts/{contractId}/auto/financing',
            investmentContractsLogDetail: 'investment/contracts/log/{operateId}',
            financingProductsDetail: 'financing/products/{productId}',
        },
        earningsV1: {
            financingProductsAutoSubscribe: 'v1/financing/products/{productId}/auto/subscribe',
            financingContractsAutoSubscribe: 'v1/financing/contracts/{contractId}/auto/subscribing',
            investmentProductsRunning: 'v1/investment/products/{productId}/running',
            investmentContractsStop: 'v1/investment/contracts/{contractId}/stop',
            fixedDepositProductSubscribe: 'v1/fixed-deposit/products/{id}',
            fixedDepositRevoke: 'v1/fixed-deposit/logs/{id}',
            fixedDepositProducts: 'v1/fixed-deposit/products',
            fixedDepositProductDetail: 'v1/fixed-deposit/products/{id}',
            fixedDepositLogs: 'v1/fixed-deposit/logs',
            fixedDepositContracts: 'v1/fixed-deposit/contracts',
            fixedDepositContractDetail: 'v1/fixed-deposit/contracts/{id}',
        },
        favoriteCustom: {
            favoriteRecommend: 'v1/market/favorites/recommend',
            hotSearch: 'v1/market/symbols/hot',
            favoriteAdd: 'v1/market/favorites',
            favoriteDelete: 'v1/market/favorites',
            favoriteSort: 'v1/market/favorites/sort',
            // favoriteZoneAdd: 'favorite/zone/add',
            // favoriteZoneDelete: 'favorite/zone/delete',
            // favoriteZoneSort: 'favorite/zone/sort',
            favoriteList: 'v1/market/favorites',
            // updateFavorite: 'v1/market/favorites/sequences',
            topFavorite: 'v1/market/favorites/top',
        },
        repay: {
            assets: 'v1/trading/margin/assets',
            repay: 'v1/trading/margin/repay',
            repayList: 'v1/trading/margin/repayments',
            preview: 'v1/trading/margin/repay/preview',
            repayments: 'v1/trading/margin/repayments/{repayment_id}',
        },
        merchant: {
            payment: {
                list: 'payment/channel/list',
                oftenUsedList: 'payment/oftenused/channel/list',
                detail: 'payment/channel/detail',
                add: 'payment/channel/add',
                modify: 'payment/channel/modify',
                updateStatus: 'payment/channel/status/update',
            },
            info: 'p2p/merchant/info',
            update: 'p2p/merchant/update',
            applyList: 'p2p/merchant/apply/list',
            applyCheck: 'v1/p2p/merchant/apply/check',
            apply: 'p2p/merchant/apply',
            applyDetail: 'p2p/merchant/apply/detail',
            kycDetail: 'v1/kyc/result',
            adList: 'p2p/merchant/myads/list',
            adPost: 'p2p/merchant/ads/post',
            adUpdate: 'p2p/merchant/ads/update',
            adCancel: 'p2p/merchant/ads/cancel',
            adOnline: 'p2p/merchant/ads/online',
        },
        circle: {
            bankCardList: 'v1/customer/payment/terms',
            addBankCard: 'v1/customer/payment/terms',
            supportedBankList: 'v1/customer/payment/banks',
            bankCardDetail: 'v1/customer/payment/terms/{id}',
            modifyBankCard: 'v1/customer/payment/terms/{id}',
            depositInstruction: 'v1/pay/fiat/deposit/instructions',
            withdrawApply: 'v1/pay/fiat/withdraw/apply',
            orderList: 'v1/pay/fiat/orders',
        },
        c2cAccount: {
            transfer: 'v1/account/transfer',
        },
        tiny: {
            assets: 'v1/trading/dust/assets',
            preview: 'v1/trading/dust/preview',
            exchange: 'v1/trading/dust',
            ordersDetail: 'v1/trading/dust/orders/ids',
            orders: 'v1/trading/dust/orders',
        },
        airdrop: {
            claimHistory: 'v1/airdrop/last/receive',
            openAirdrop: 'v1/airdrop/open',
            openAirdropCheck: 'v1/airdrop/open/check',
            simpleDetail: 'v1/airdrop/release/simple/{id}',
            sendDetail: 'v1/airdrop/release/{id}',
            claimDetail: 'v1/airdrop/receive/{id}/{receiveId}',
            sendRecord: 'v1/airdrop/release/history',
            claimRecord: 'v1/airdrop/receive/history',
            airdropRule: 'v1/airdrop/rule',
            airdropSend: 'v1/airdrop/release_drop',
        },
        market: {
            explore: 'v1/market/explores',
            trends: 'v1/market/trends',
            popularCurrencies: 'v1/market/currencies/popular'
        }
    },
};
//# sourceMappingURL=config.js.map